import { Paper, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import PaymentsIcon from "@mui/icons-material/Payments";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import PaidIcon from "@mui/icons-material/Paid";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { formatCurrency, formatInteger } from "../../../../../formatters";
import { BrandDailyRow, BrandMtdRow } from "../../../../../Brands/brandsApiMapping";

const PRIMARY = "#8E24AA";

interface BrandsKpiCardsProps {
  dailyRows: BrandDailyRow[];
  mtdRows: BrandMtdRow[];
}

// Mobile-specific 2-per-row KPI grid (mockup: 2x2), same values/calculations
// as the desktop BrandsKpiCards.tsx (checklist Section 10.4).
export default function BrandsKpiCards({ dailyRows, mtdRows }: BrandsKpiCardsProps) {
  const income = mtdRows.reduce((total, row) => total + row.income, 0);
  const reported = mtdRows.reduce((total, row) => total + row.reported, 0);
  const paid = mtdRows.reduce((total, row) => total + row.paid, 0);
  const qualified = dailyRows.reduce((total, row) => total + row.qualified, 0);
  const epq = reported ? income / reported : 0;
  const epp = paid ? income / paid : 0;

  return (
    <Grid container spacing={1.25}>
      <Grid size={6}>
        <Paper variant="outlined" sx={{ p: "13px 14px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1, fontSize: 11 }}>
              TOTAL INCOME
            </Typography>
            <PaymentsIcon sx={{ color: "#2E7D32", fontSize: 18 }} />
          </Stack>
          <Typography fontWeight={700} sx={{ mt: 0.75, fontSize: 25, color: "#1a1a1a", lineHeight: 1.1 }}>
            {formatCurrency(income)}
          </Typography>
          <Typography sx={{ color: "#9e9e9e", fontSize: 11, display: "block", mt: 0.5 }}>MTD</Typography>
        </Paper>
      </Grid>

      <Grid size={6}>
        <Paper variant="outlined" sx={{ p: "13px 14px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1, fontSize: 11 }}>
              REPORTED
            </Typography>
            <TaskAltIcon sx={{ color: PRIMARY, fontSize: 18 }} />
          </Stack>
          <Typography fontWeight={700} sx={{ mt: 0.75, fontSize: 25, color: "#1a1a1a", lineHeight: 1.1 }}>
            {formatInteger(reported)}
          </Typography>
          <Typography sx={{ color: "#9e9e9e", fontSize: 11, display: "block", mt: 0.5 }}>
            successfully reported
          </Typography>
        </Paper>
      </Grid>

      <Grid size={6}>
        <Paper variant="outlined" sx={{ p: "13px 14px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1, fontSize: 11 }}>
              PAID LEADS
            </Typography>
            <PaidIcon sx={{ color: PRIMARY, fontSize: 18 }} />
          </Stack>
          <Typography fontWeight={700} sx={{ mt: 0.75, fontSize: 25, color: "#1a1a1a", lineHeight: 1.1 }}>
            {formatInteger(paid)}
          </Typography>
          <Typography sx={{ color: "#9e9e9e", fontSize: 11, display: "block", mt: 0.5 }}>
            {formatInteger(qualified)} qualified
          </Typography>
        </Paper>
      </Grid>

      <Grid size={6}>
        <Paper variant="outlined" sx={{ p: "13px 14px", borderColor: "#ececec" }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" fontWeight={600} color={PRIMARY} sx={{ flex: 1, fontSize: 11 }}>
              EPQ
            </Typography>
            <TrendingUpIcon sx={{ color: PRIMARY, fontSize: 18 }} />
          </Stack>
          <Typography fontWeight={700} sx={{ mt: 0.75, fontSize: 25, color: "#1a1a1a", lineHeight: 1.1 }}>
            {formatCurrency(epq)}
          </Typography>
          <Typography sx={{ color: "#9e9e9e", fontSize: 11, display: "block", mt: 0.5 }}>
            EPP {formatCurrency(epp)}
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
